import { Typography } from "@shared/ui.primitives";
import { cloudinaryLoader } from "@shared/utils.cloudinary";
import { getRegion } from "@shared/utils.locale";
import Image from "next/image";

import {
  imageContainer,
  labelContainer,
  tileContainer
} from "./AnniversaryGiftProductCard.css";

type Props = {
  gift: {
    id: string;
    label?: string | null;
    image: string;
    slug: string;
  };
  setNextVisibility?: (visible: boolean, callback?: () => void) => void;
  elementClicked?: (payload: Record<string, unknown>) => void;
  idx: number;
};

export const AnniversaryGiftProductCard: React.FC<Props> = ({
  gift: { slug, image, label },
  setNextVisibility,
  elementClicked,
  idx
}) => {
  const region = getRegion();
  const urlPrefix = region === "us" ? "/us" : "";

  return (
    <a
      href={`${urlPrefix}/products/${slug}`}
      onClick={() => {
        if (setNextVisibility) {
          setNextVisibility(false);
        }
        if (!elementClicked) {
          return;
        }
        elementClicked({
          details: `${slug}`,
          details2: `${idx + 1}`,
          contentUrl: `${window.location.origin}${urlPrefix}/products/${slug}`
        });
      }}
    >
      <div
        className={tileContainer}
        data-testid="anniversary-gift-product-card"
      >
        <Image
          className={imageContainer}
          src={image}
          alt={slug}
          quality={100}
          width={409}
          height={292}
          priority
          sizes="300px"
          loader={cloudinaryLoader}
        />
        <div className={labelContainer}>
          <Typography variant="label-sm">{label}</Typography>
        </div>
      </div>
    </a>
  );
};
